/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Feedback } from '../../models/feedback';

export interface ApiRequestFeedbackGetFeedbackGet$Params {
  mid?: number;
  sid?: number;
}

export function apiRequestFeedbackGetFeedbackGet(http: HttpClient, rootUrl: string, params?: ApiRequestFeedbackGetFeedbackGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Feedback>> {
  const rb = new RequestBuilder(rootUrl, apiRequestFeedbackGetFeedbackGet.PATH, 'get');
  if (params) {
    rb.query('mid', params.mid, {});
    rb.query('sid', params.sid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Feedback>;
    })
  );
}

apiRequestFeedbackGetFeedbackGet.PATH = '/api/request/feedback/GetFeedback';
